module.exports = __webpack_public_path__ + "img/google-icon.30db178d.svg";